const getStyles = () => {
  return {
    // Main Section
    heroSection: {
      position: 'relative',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden'
    },

    // Parallax Background
    parallaxBackground: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 0,
      backgroundImage:
        'linear-gradient(135deg, #4f46e594 0%, #38bdf875 100%), url(/images/hero-bg.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      willChange: 'transform', // Optimize parallax performance
      '&::before': {
        content: '""',
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.4))'
      }
    },

    // Gradient Overlay
    gradientOverlay: {
      position: 'absolute',
      inset: 0,
      background: 'linear-gradient(135deg, #4f46e594 0%, #38bdf875 100%)',
      zIndex: 1,
      animation: 'glow 3s ease-in-out infinite alternate',
      opacity: 0.7
    },

    // Content
    container: {
      position: 'relative',
      padding: '20px 0px',
      zIndex: 2
    },
    content: {
      // maxWidth: '900px',
      // margin: '0 auto',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: '32px',
      animation: 'fadeIn 1s ease-out'
    },
    heroTitle: {
      fontSize: '60px',
      fontWeight: 'bold',
      color: '#ffffff',
      lineHeight: 1.2,
      '@media (max-width: 768px)': {
        fontSize: '40px'
      }
    },
    glowText: {
      color: '#64ffda',
      animation: 'glow 2s ease-in-out infinite alternate',
      display: 'inline-block'
    },
    heroSubtitle: {
      fontSize: '1.25rem',
      color: 'rgba(255, 255, 255, 0.9)',
      lineHeight: 1.6,
      '@media (min-width: 768px)': {
        fontSize: '1.5rem'
      }
    },
    mainHeadline: {
      color: '#ffffff'
    },
    headlineLine1: {
      fontSize: { xs: '30px', md: '40px', lg: '65px' },
      display: 'block',
      fontWeight: 'bold',
      fontFamily: 'Poppins'
    },
    headlineLine2: {
      fontSize: { xs: '30px', md: '40px', lg: '65px' },
      display: 'block',
      marginTop: '8px',
      fontWeight: 'bold',
      fontFamily: 'Poppins'
    },
    textGradient: {
      background: 'linear-gradient(135deg, #2920deff 0%, #0daef3ff 100%)',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      color: 'transparent'
    },

    textGlow: {
      color: '#00FFFF',
      textShadow: '0 0 20px rgba(255, 255, 255, 0.5)'
    },

    subtitleLine: {
      fontSize: { xs: '1.5rem', md: '2.25rem', lg: '50px' },
      display: 'block',
      marginTop: '8px',
      color: 'rgba(255, 255, 255, 0.8)',
      fontFamily: 'Poppins',
      fontWeight: 'bold'
    },

    subtitle: {
      fontSize: { xs: '1.1rem', md: '1.5rem' },
      color: 'rgba(255, 255, 255, 0.8)',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: 'Poppins',
      lineHeight: 1.7
    },

    subtitleHighlight: {
      color: '#ffffff',
      fontWeight: 600
    },

    accentText: {
      color: '#00FFFF',
      fontWeight: 600
    },

    // CTA Buttons
    ctaContainer: {
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      gap: '16px',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: '16px'
    },

    primaryButton: {
      fontSize: '1rem',
      padding: '14px 24px',
      borderRadius: '12px',
      fontWeight: 600,
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      color: '#ffffff',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 15px rgba(12, 90, 219, 0.3)',
      '&:hover': {
        opacity: 0.9,
        transform: 'scale(1.05)',
        boxShadow: '0 8px 25px rgba(12, 90, 219, 0.5)'
      }
    },

    outlineButton: {
      fontSize: '1rem',
      padding: '14px 24px',
      borderRadius: '12px',
      fontWeight: 600,
      background: 'rgba(255, 255, 255, 0.37)',
      color: '#ffffff',
      border: '2px solid rgba(12, 90, 219, 0.5)',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      '&:hover': {
        opacity: 0.9,
        transform: 'scale(1.05)',
        boxShadow: '0 8px 25px rgba(12, 90, 219, 0.5)',
        background: 'rgba(255, 255, 255, 0.37)',
        border: '2px solid rgba(12, 90, 219, 0.8)'
      }
    },
    buttonIcon: {
      marginLeft: '8px',
      transition: 'transform 0.3s ease'
    },
    strongText: {
      color: '#ffffff',
      fontWeight: 600
    },

    // Buttons
    buttonsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: '16px',
      '@media (min-width: 640px)': {
        flexDirection: 'row'
      }
    },

    // Timeline Visualization
    timelinePaginationWrapper: {
      position: 'relative',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      marginTop: '8px',
      marginBottom: '8px'
    },
    timelineContainer: {
      paddingTop: '48px',
      animation: 'fadeIn 1s ease-out 0.3s both',
      display: 'flex',
      justifyContent: 'center'
    },
    timelineCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: '16px',
      padding: '24px 16px',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.2)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      width: '100%',
      maxWidth: '1100px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px'
    },
    timelineBox: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      minHeight: '130px', // just enough to fit icons + labels
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        minHeight: 'auto'
      }
    },
    timelineTitle: {
      fontSize: '1.5rem',
      fontWeight: 600,
      marginBottom: '24px',
      color: '#1a202c',
      textAlign: 'center'
    },
    timelineContent: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '16px',
      transition: 'transform 0.4s ease-in-out',
      flexWrap: 'nowrap',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        gap: '24px'
      }
    },
    timelineConnector: {
      height: '4px',
      width: '60px',
      flexShrink: 0,
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      borderRadius: '2px',
      '@media (max-width: 768px)': {
        display: 'none'
      }
    },
    arrowButton: {
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      color: '#fff',
      minWidth: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'scale(1.1)',
        boxShadow: '0 8px 20px rgba(56, 189, 248, 0.5)'
      },
      '@media (max-width: 600px)': {
        minWidth: '32px',
        height: '32px'
      }
    },
    pageIndicator: {
      textAlign: 'center',
      color: '#4f46e5',
      marginTop: '10px',
      fontWeight: 500
    },

    // Timeline Step
    timelineStep: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '12px',
      flex: 1,
      minWidth: '120px'
    },
    stepIconContainer: {
      width: '64px',
      height: '64px',
      borderRadius: '50%',
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#ffffff',
      boxShadow: '0 10px 25px rgba(100, 255, 218, 0.4)'
    },
    stepIcon: {
      fontSize: '32px'
    },
    stepContent: {
      textAlign: 'center'
    },
    stepDay: {
      fontWeight: 'bold',
      color: '#1a202c',
      fontSize: '1.1rem',
      marginBottom: '4px'
    },
    stepLabel: {
      fontSize: '0.9rem',
      color: '#6b7280'
    }
  };
};

export default getStyles;
